// API URLs
// Primary relayer (gasless tx submission) goes through our nginx proxy, same
// pattern as CLOB_API_URL_V2. The proxy forwards to relayer-v2.polymarket.com
// and passes the client's POLY_BUILDER_* headers through untouched (RelayClient
// attaches them itself via the /api/polymarket/trading remote signer — no
// static cred injection at the proxy, unlike the CLOB block). On 429 we fall
// back to hitting Polymarket's relayer directly.
export const RELAYER_URL = 'https://polymarket-relayer-v2.pzp.money/'
export const RELAYER_FALLBACK_URL =
	process.env.RELAY_CLIENT_URL || 'https://relayer-v2.polymarket.com/'

// V1 CLOB — used until April 28, 2026 ~11:00 UTC cutover, then dead.
// Kept for reference until V1 callsites are removed. Do not add new uses.
export const CLOB_API_URL = 'https://polymarket-clob.pzp.money'

// V2 CLOB — points at our nginx proxy which forwards to clob-v2.polymarket.com
// pre-cutover and to clob.polymarket.com (V2) post-cutover. Hot-swap is
// handled by clob-client-v2 SDK + the proxy upstream config.
export const CLOB_API_URL_V2 = 'https://polymarket-clob-v2.pzp.money'

export const GAMMA_API_URL = 'https://gamma-api.polymarket.com'

export const POLYMARKET_PROFILE_URL = (address: string) => `https://polymarket.com/${address}`

// RPC URLs
export const POLYGON_RPC_URL = process.env.NEXT_PUBLIC_POLYGON_RPC_URL || 'https://polygon-rpc.com'

// Remote signing — STILL USED by RelayClient (HMAC auth for gasless tx via
// builder-signing-sdk). NOT used by V2 ClobClient — V2 signs orders locally
// with builderCode field. Do not delete.
export const REMOTE_SIGNING_URL = () =>
	typeof window !== 'undefined'
		? `${window.location.origin}/api/polymarket/trading`
		: '/api/polymarket/trading'

// V2 Exchange contracts (Polygon mainnet).
// Source: https://docs.polymarket.com/migrations/clob-v2
export const POLYMARKET_EXCHANGE_V2 = '0xE111180000d2663C0091e4f400237545B87B996B' as const
export const POLYMARKET_NEG_RISK_EXCHANGE_V2 = '0xe2222d279d744050d28e00520010520000310F59' as const

// Builder code: bytes32 attribution identifier from polymarket.com/settings?tab=builder.
// Public — appears onchain in every attributed order. Empty string = no
// attribution (orders still execute, but no revenue share / leaderboard credit).
export const POLY_BUILDER_CODE: `0x${string}` | '' =
	(process.env.NEXT_PUBLIC_POLY_BUILDER_CODE as `0x${string}` | undefined) || ''

// Other constants
export const POLYGON_CHAIN_ID = 137
export const SESSION_STORAGE_KEY = 'polymarket_trading_session'
